import React from "react";
import { StyledHeaderImage, StyledDiv, StyledCardWrapper, StyledTitle, StyleHeaderImageWrapper } from "./style";

interface Props {
  imageLink: string;
  alt: string;
}

const HeaderImage: React.FC<Props> = ({ imageLink, alt }) => {
  return (
    <>
      <StyledDiv>
        <StyleHeaderImageWrapper>
          <StyledHeaderImage src={imageLink} alt={alt} />
        </StyleHeaderImageWrapper>
        <StyledCardWrapper>
          <StyledTitle level={3}>Bindeleddet NTNU</StyledTitle>
        </StyledCardWrapper>
      </StyledDiv>
    </>
  );
};

export default HeaderImage;
